<template>
  <div>
    <!-- <pre>{{invoiceSidebarData}}</pre> -->
    <vs-card class="invoice_preview_card">
      <div class="sm:flex flex-wrap justify-between">
        <div>
          <img
            style="width: 100px"
            src="http://scoolio-dev.track-progress.com/img/scoolio.66f0960f.png"
            alt="logo"
          />
          <!-- <p>2546  Cheshire Road, USA, Pincode: 110022</p> -->
        </div>
        <div>
          <h4 class="mb-2">Invoice # {{invoiceSidebarData.invoice_id}}</h4>
          <div>
            <div class="flex">
              <strong>Date Issued: </strong>
              <p class="ml-2">{{ invoiceSidebarData.created_at }}</p>
            </div>
          </div>
        </div>
      </div>
      <vs-divider />

      <div class="flex flex-wrap">
        <div class="md:w-1/2 pr-0 md:pr-4 mb-4 md:mb-0 w-full">
          <strong>Bill from</strong>
          <p class="my-2">
            <!-- <span v-if="platformCustomerInfo.brand_company_name">{{
              platformCustomerInfo.brand_company_name
            }}</span> -->
            <!-- {{ get_userinfo_data.first_name }}{{ get_userinfo_data.last_name }} -->

            <!-- <pre>{{platformCustomerInfo}}</pre> -->
          </p>
          <!-- <p v-if="platformCustomerInfo.email">
            {{ platformCustomerInfo.email }}
          </p>
          <p v-if="platformCustomerInfo.phone">
            {{ platformCustomerInfo.phone }}
          </p>
          <address>{{ platformCustomerInfo.address1 }}</address>
          <address>{{ platformCustomerInfo.address2 }}</address>
          <p>{{ platformCustomerInfo.state }}</p>
          <p>{{ platformCustomerInfo.city }}</p>
          <p>{{ platformCustomerInfo.country_details.country_name }}</p>
          <p>{{ platformCustomerInfo.zip }}</p> -->


        </div>
        <div class="md:w-1/2 w-full md:text-right">
          <strong>Bill to</strong>
          <p class="my-2">
            {{ invoiceSidebarData.clientUser.first_name }}
            {{ invoiceSidebarData.clientUser.last_name }}
          </p>
          <address>
            {{ invoiceSidebarData.clientUser.client_user_address.address1 }}
          </address>
          <address>
            {{ invoiceSidebarData.clientUser.client_user_address.address2 }}
          </address>

          <p>{{ invoiceSidebarData.clientUser.email }}</p>
          <p>{{ invoiceSidebarData.clientUser.mobile }}</p>
        </div>
      </div>
      <vs-divider />

      <div class="cstm_vuexy_table">
        <table class="invoice-table w-full">
          <tr>
            <th>Item</th>
            <!-- <th>Description</th> -->
            <th>Price</th>
          </tr>
          <tr>
            <td>
              <span>
                {{ invoiceSidebarData.course_name }}
              </span>
            </td>
            <!-- <td>Instrumental Elite: Guitar</td> -->
            <td>
              <span>&#163;  {{ invoiceSidebarData.amount }}</span>
            </td>
          </tr>
          <tr>
            <th>Subtotal</th>
            <td>
              <span>&#163; 00.00</span>
            </td>
          </tr>
          <tr>
            <th>Discount</th>
            <td>
              <span>&#163; 00.00</span>
            </td>
          </tr>
          <tr>
            <th>Tax</th>
            <td>0%</td>
          </tr>
          <tr>
            <th>Invoice Total</th>
            <td>
              <span>&#163;  {{ invoiceSidebarData.amount }}</span>
            </td>
          </tr>
          <!--   <tr>
                <th>Paid to date</th>
                <td>
                  <span>&#163; 1000</span>
                </td>
              </tr>
              <tr>
                <th>Balance (USD)</th>
                <td>
                  <span>&#163; 1000</span>
                </td>
              </tr> -->
        </table>
      </div>
      <vs-divider />

      <!--   <div class="text-right">
              <vs-button class="mx-1">Download</vs-button>
          </div> -->
    </vs-card>

    <vs-divider />
  </div>
</template>

<script>
export default {
  name: 'invoice-preview',
  props: {
    invoiceSidebarData: {},
    schoolAddress: {},
    platformCustomerInfo: {}
  }

  // mounted () {
  //   console.log(this.schoolAddress)
  // }
}
</script>

<style>
.invoice_preview_card {
  padding: 15px;
}
.invoice_preview_card .vs-card--content {
  font-size: 14px;
}
</style>